module.exports = __webpack_public_path__ + "static/img/bgc.b20f2e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Login/bgc.png
// module id = MOh/
// module chunks = 19